<div id="layout">
  <div class="container px-0">
    <div class="content d-flex">
      <div class="sidebar-container bg-white pr-1 pr-lg-3 pr-xl-4" *ngIf="sideMenuVisible">
        <app-side-menu></app-side-menu>
      </div>

      <main>
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>

</div>


